module.exports = __webpack_public_path__ + "static/media/organizer_8.db9369e6.jpg";